import { render, staticRenderFns } from "./HOOrderListTab.vue?vue&type=template&id=3c47355b&"
import script from "./HOOrderListTab.vue?vue&type=script&lang=ts&"
export * from "./HOOrderListTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports